"use strict";

exports.__esModule = true;
exports.ColorPickerFormGroup = void 0;
var _react = _interopRequireDefault(require("react"));
var _ColorPicker = require("./ColorPicker");
var _core = require("@blueprintjs/core");
var _Translator = require("../../Core/Translator");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var ColorPickerFormGroup = exports.ColorPickerFormGroup = function ColorPickerFormGroup(_ref) {
  var color = _ref.color,
    setColor = _ref.setColor;
  var _React$useContext = _react["default"].useContext(_Translator.TranslatorContext),
    translate = _React$useContext.translate;
  return /*#__PURE__*/_react["default"].createElement(_core.FormGroup, {
    label: translate("ColorPickerFormGroup.SelectColor", "Color"),
    helperText: translate("ColorPickerFormGroup.picker.helperText", "Select a color for the chart")
  }, /*#__PURE__*/_react["default"].createElement(_ColorPicker.ColorPicker, {
    "data-testid": "core.color-picker-form-group-test-id",
    value: color || "#68ccca",
    onChange: function onChange(color) {
      return color && setColor(color);
    }
  }));
};